var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-list"},[_c('ul',_vm._l((_vm.labels),function(label,index){return _c('li',{key:label,class:{ 'is-current': index === _vm.current }},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.handleClickItem(index)}}},[_vm._v(_vm._s(label))])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72429909","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TabList/tab-list.vue
// module id = null
// module chunks = 